module.exports = __webpack_public_path__ + "static/media/annElise.8569f956.jpg";